/* global instantsearch algoliasearch */
function search_init(index_name) {
  var search_value = document.querySelector("input[type=search]");
  var search_heading = document.querySelector(".search_heading");

  if(search_value != null){
    search_value.value = "";
  }
  search_heading.style.display = "none";

  const search = instantsearch({
    indexName: index_name,
    // searchClient: algoliasearch('5995UEL490', '3113a92d4c2d6ee71efb15a8fc5a270a') // replaced with domain restricted API Key
    searchClient: algoliasearch(
      "5995UEL490",
      "29ae0732c63d28b15453e3cc8b0d0aaf"
    ), // replaced with domain restricted API Key
  });
  if (index_name == "atlas_shopify_products") {
    template_item = `
                <div class="item_box">
                <a href="https://astral-theme-development.myshopify.com/products/{{handle}}?variant={{ objectID }}">
                    <div class="featured_image" style="background-image:url({{ product_image }});" alt="{{ handle }}" ></div>
                    <div class="item_content">
                        <div class="post_category secondary_sub_heading">{{ product_type }}</div>
                        <h5 class="post_title">
                            {{ title }}
                        </h5>
                        <span class="post_variations">{{ variants_count }} types</span>
                        <div class="post_excerpt">
                            $ {{ price }}
                        </div>
                    </div>
                </a>
            `;
    filterattribute = "product_type";
    filterLabel = "All Products";
  } else if (index_name == "atlas_wordpress_posts") {
    template_item = `
                <div class="item_box">
                <a href="{{ guid }}">
                    <div class="featured_image {{post_type}}" data-bg="{{featured_image}}" style="background-image:url({{featured_image}});" alt="{{handle}}" ></div>
                      <div class="item_content">
                      <div class="post_category secondary_sub_heading {{post_type}}">{{ category_name }}
                          <span class="page_subtitle">PAGE</span>
                          <span class="ambassador_subtitle">AMBASSADOR</span>
                      </div>
                        <h5 class="post_title">
                            {{ post_title }}
                        </h5>
                    </div>
                </a>
            `;
    filterattribute = "category_name";
    filterLabel = "All Stories";
  } else {
    index_name == "atlas_shopify_products";
  }

  search.addWidgets([
    instantsearch.widgets.searchBox({
      container: "#searchbox",
      placeholder: "Article name or keywords ...",
      cssClasses: {
        submitIcon: "astral_submitIconSVG",
      },
    }),
    instantsearch.widgets.clearRefinements({
      container: "#clear-refinements",
      templates: {
        resetLabel: filterLabel,
      },
    }),
    instantsearch.widgets.refinementList({
      container: "#refinement-list",
      attribute: filterattribute,
      sortBy: ["name:asc"],
      templates: {
        item: ` 
                <button href="{{ url }}">
                    <span>{{ label }}</span>
                </button>`,
      },
    }),
    instantsearch.widgets.hits({
      container: "#hits",
      templates: {
        item: template_item,
        empty:
          " " +
          "<style>.filter_container,.search_heading{display:none !important;}</style>" +
          '<div class="no_results_section">' +
          '<h3 class="heading_no_results">Sorry, no results found.</h3>' +
          '<p class="primary_colored_paragragh">Hopefully this image of our friend will make up for it.</p>' +
          '<img src="https://explore.astraldesigns.com/wp-content/uploads/2022/06/empty_search_image.webp" class="no_results_image">' +
          "</div>",
      },
    }),
    instantsearch.widgets.pagination({
      container: "#pagination",
      showFirst: false,
      showLast: false,
    }),
    instantsearch.widgets.hitsPerPage({
      container: "#hits-per-page",
      items: [
        { label: "6 items per page", value: 6, default: true },
        { label: "9 items per page", value: 9 },
        { label: "12 items per page", value: 12 },
      ],
    }),
  ]);

  search.start();
}

var sel = document.getElementById("index_name_select");
var index_name = sel.options[sel.selectedIndex].value;
//console.log('index_name: '+index_name);
search_init(index_name);

var item_container = document.querySelector(".item_container");
var pagination_container = document.querySelector(".pagination_container");
var search_heading = document.querySelector(".search_heading");
var search_keyword = document.querySelector("#search_keyword");

search_heading.style.display = "none";

var searchinputElement = document.querySelector(".ais-SearchBox-input");
searchinputElement.addEventListener("keyup", (event) => {
  var searchinput = searchinputElement.value;

  search_heading.style.display = "block";
  search_keyword.innerHTML = searchinput;

  //console.log(' searchinput: '+searchinput);

  if (searchinput.length < 1) {
    search_heading.style.display = "none";
    var index_name = sel.options[sel.selectedIndex].value;
    search_init(index_name);
  }
});
